import {defaultAxios} from "../base";

interface IFetchHousePreList {
    custSeq: number;
}

// 주담대 가심사 결과 상품 리스트
export const fetchHousePreList = async (params: IFetchHousePreList) => {
    return await defaultAxios().post('/house/cust/preList', params)
}